import ContentDiff from './ContentDiff';

export default ContentDiff;